var map = {
	"./international.de-CH.json": 1488,
	"./international.de-DE.json": 1489,
	"./international.en-CA.json": 1490,
	"./international.en-GB.json": 1491,
	"./international.en-IN.json": 1492,
	"./international.en-ME.json": 1493,
	"./international.en-US.json": 1494,
	"./international.es-EM.json": 1495,
	"./international.es-ES.json": 1496,
	"./international.fr-BE.json": 1497,
	"./international.fr-CA.json": 1498,
	"./international.fr-CH.json": 1499,
	"./international.nl-BE.json": 1500,
	"./international.nl-NL.json": 1501,
	"./international.pl-PL.json": 1502,
	"./international.pt-BR.json": 1503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1487;